// src/hooks/useResponsive.js
import { useState, useEffect, useMemo } from "react";

const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
};

export const useResponsive = () => {
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 0
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    // Debounce
    let timeoutId;
    const debouncedResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(handleResize, 150);
    };

    window.addEventListener("resize", debouncedResize);

    return () => {
      window.removeEventListener("resize", debouncedResize);
      clearTimeout(timeoutId);
    };
  }, []);

  // Device type detection
  const deviceType = useMemo(
    () => ({
      isMobile: windowWidth < BREAKPOINTS.mobile,
      isTablet:
        windowWidth >= BREAKPOINTS.mobile && windowWidth < BREAKPOINTS.tablet,
      isDesktop: windowWidth >= BREAKPOINTS.tablet,
    }),
    [windowWidth]
  );

  // Device info
  const deviceInfo = useMemo(() => {
    const userAgent =
      typeof navigator !== "undefined" ? navigator.userAgent : "";

    return {
      isTouchDevice: "ontouchstart" in window || navigator.maxTouchPoints > 0,
      isIOS: /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream,
      isAndroid: /Android/.test(userAgent),
      isIPad: /iPad/.test(userAgent),
      isSafari: /^((?!chrome|android).)*safari/i.test(userAgent),
      isChrome: /Chrome/.test(userAgent),
      isFirefox: /Firefox/.test(userAgent),
    };
  }, []);

  return {
    ...deviceType,
    ...deviceInfo,
    windowWidth,
  };
};
